'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('./button');

var _button2 = _interopRequireDefault(_button);

var _ExternalServiceTypes = require('../constants/ExternalServiceTypes');

var _ExternalServiceTypes2 = _interopRequireDefault(_ExternalServiceTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ExternalServiceUpdateURL = '/account/updateExternalService';
var MyAccountIntegrationsHomeURL = '/home/myAccount?current_tab=integrations';

var IntegrationActivationButton = _react2['default'].createClass({
    displayName: 'IntegrationActivationButton',


    propTypes: {
        'isActive': _react2['default'].PropTypes.bool.isRequired,
        'serviceTypeCode': _react2['default'].PropTypes.string,
        'buttonLink': _react2['default'].PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'buttonLink': '#'
        };
    },

    // Original logic moved from myAccount.php
    clickHandler: function clickHandler(event) {
        event.stopPropagation();
        event.preventDefault();

        var el = $(event.target).closest('div');
        var isActivated = el.hasClass('is-activated');
        var textContainer = $('button .l-nowrap > span', el);
        var text = $.trim(textContainer.text());
        var servTypeCode = $(' > a button', el).attr('rel');

        var postData = {
            'service_type': servTypeCode,
            'is_deactivate': isActivated ? '1' : '0',
            'csrf_token': $('#update_ext_serv_csrf_token').val()
        };

        // If activating Google Drive
        if (!isActivated && servTypeCode == _ExternalServiceTypes2['default'].SERVICE_TYPE_CODE_GOOGLE_DRIVE) {
            if ($.browser.msie && parseInt($.browser.version, 10) < 8) {
                $.fancybox('<div class="browser_warning"><strong>This option requires a more up to date browser</strong><p>Download the latest <a href="http://windows.microsoft.com/en-US/internet-explorer/downloads/ie" target="_blank">Microsoft Internet Explorer</a> or <a href="http://www.google.com/chrome/" target="_blank">Google Chrome</a></p></div>', { 'padding': 20 });
                return;
            }
        }

        // If activating HubSpot
        if (!isActivated && servTypeCode == _ExternalServiceTypes2['default'].SERVICE_TYPE_CODE_HUBSPOT) {
            // Show a modal to prompt for a Hub ID
            $.fancybox({
                'href': '#hubspot_prompt',
                'height': 390,
                'width': 640,
                'autoDimensions': false,
                'margin': 0,
                'padding': 0,
                'scrolling': 'no',
                'modal': true,
                'autoScale': false,
                'onComplete': function onComplete() {
                    $("#hubspot-hub-id").focus();
                }
            });
            return;
        }

        var showAsBusy = function showAsBusy(isBusy) {
            textContainer.html(isBusy ? 'Activating...' : text);
        };

        showAsBusy(true);

        $.ajax({
            'dataType': 'json',
            'type': 'POST',
            'url': ExternalServiceUpdateURL,
            'data': postData,
            success: function success(data, textStatus, jqXHR) {
                showAsBusy(false);
                if (data.auth_url) {
                    window.location = data.auth_url.replace(/&amp;/g, '&'); // FIXME: Needed because it gets returned HTML-encoded
                } else {
                        window.location = MyAccountIntegrationsHomeURL;
                    }
            },
            error: function error() {
                showAsBusy(false);
                alert('An error occurred, try again or contact support at support@hellosign.com'); // FIXME - get email address dynamically, and localize text (DB)
            }
        });
    },

    render: function render() {
        var hasCustomButtonLink = this.props.buttonLink !== '#';
        var btn = _jsx(_button2['default'], {
            buttonText: this.props.isActive ? 'Deactivate' : 'Activate',
            buttonLink: hasCustomButtonLink ? this.props.buttonLink : void 0,
            buttonClass: 'border-1-grasshopper',
            buttonColor: this.props.isActive ? 'grasshopper' : 'white',
            buttonTextColor: this.props.isActive ? 'white' : 'grasshopper',
            buttonHoverTextColor: 'white',
            buttonHoverColor: 'grasshopper',
            openInNewWindow: true,
            buttonAttrs: this.props.serviceTypeCode ? { 'rel': this.props.serviceTypeCode } : null,
            buttonLinkUsePost: false,
            onClick: hasCustomButtonLink ? void 0 : this.clickHandler
        });

        return btn;
    }
});

module.exports = IntegrationActivationButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/integration-activation-button.jsx
 ** module id = 630
 ** module chunks = 0
 **/